import Service 			from "./../../Libs/Service";

let DisplayObject = new Service({

	Name: "DisplayObject",

	Libraries: [],

	Events: {

		"Selected Version Changed": function() {

			this.selectDisplayObject(null);

		}

	},

	Actions: {

		//Получение всех экранов проекта или версии
		"DisplayObjects": function(displayObjects, data) {

			if (data.DisplayObjectsProjectId) {

				this.setDisplayObjects(displayObjects);

				//Первоначальная загрузка экранов всех версий проекта
				Broadcast.call("Project DisplayObjects Loaded");

			} else if (data.DisplayObjectsVersionId) {

				this.setDisplayObjects(displayObjects);

				//Первоначальная загрузка экранов одной версии (дублирование версии или создание из шаблона)
				Broadcast.call("Version DisplayObjects Loaded");

			}

		},

		//Получение всех экранов проекта или версии
		"DisplayObjectsHash": function(displayObjects, data) {

			// 2022.07.23 важно сначало обновить весь кэш и только потом вызывать события иначе при переименовании дочерний элемент
			// не найдёт своего родителя (нужно сначала оба объекта изменить и только потом вызывать события изменения)
			let oldDisplayObjects = {};

			_.each(displayObjects, (displayObject, displayObjectCodename) => {

				oldDisplayObjects[displayObjectCodename] = this.DisplayObjectsByVersionByScreenByCodename[data['DisplayObjectsHashVersionId']]?.[data['DisplayObjectsHashScreenCodename']]?.[displayObjectCodename];

				this.setDisplayObject(data['DisplayObjectsHashVersionId'], data['DisplayObjectsHashScreenCodename'], displayObjectCodename, displayObject);

			});

			_.each(displayObjects, (displayObject, displayObjectCodename) => {

				this.detectDisplayObjectChanges(oldDisplayObjects[displayObjectCodename], displayObject);

			});

		},

		"DisplayObject": function(displayObject, data) {

			let oldDisplayObject = this.DisplayObjectsByVersionByScreenByCodename[data.DisplayObjectVersionId]?.[data.DisplayObjectScreenCodename]?.[data.DisplayObjectCodename];

			this.setDisplayObject(data.DisplayObjectVersionId, data.DisplayObjectScreenCodename, data.DisplayObjectCodename, displayObject);

			this.detectDisplayObjectChanges(oldDisplayObject, displayObject);

		}

	},

	init() {

		this.DisplayObjectsByVersionByScreenByCodename = {};

	},

	setDisplayObjects(versionsDisplayObjects) {

		_.each(versionsDisplayObjects, (versionDisplayObjects, versionId) => {

			this.DisplayObjectsByVersionByScreenByCodename[versionId] = versionDisplayObjects;

		});

	},

	setDisplayObject(versionId, screenCodename, displayObjectCodename, displayObject) {

		if (displayObject) {

			this.DisplayObjectsByVersionByScreenByCodename[versionId][screenCodename][displayObjectCodename] = displayObject;

			if (displayObjectCodename === this.SelectedDisplayObject?.codename) this.SelectedDisplayObject = displayObject;

		} else {

			delete this.DisplayObjectsByVersionByScreenByCodename[versionId][screenCodename][displayObjectCodename];

		}

	},

	detectDisplayObjectChanges(oldDisplayObject, newDisplayObject) {

		if (oldDisplayObject) {

			if (!newDisplayObject) {

				if (oldDisplayObject['codename'] === this.SelectedDisplayObject?.codename) {

					this.SelectedDisplayObject = null;

					Broadcast.call("Selected Display Object Cleaned", [this.SelectedDisplayObject]);

				}

				if (oldDisplayObject['version_id'] === Version.SelectedVersion?.id) Broadcast.call("Selected Version Display Object Deleted", [oldDisplayObject]);
				else Broadcast.call("Display Object Deleted", [oldDisplayObject]);

			} else {

				if (oldDisplayObject.parent !== newDisplayObject.parent || oldDisplayObject.priority !== newDisplayObject.priority) {

					//if (oldDisplayObject.codename === this.SelectedDisplayObject.codename) Broadcast.call("Selected Display Object Hierarchy Changed", [newDisplayObject]);
					Broadcast.call("Display Object Hierarchy Changed", [newDisplayObject]);

				}

				_.each(oldDisplayObject.props, (oldPropertyValue, propertyCodename) => {

					if (propertyCodename in newDisplayObject.props) {

						if (!_.isEqual(oldDisplayObject.props[propertyCodename], newDisplayObject.props[propertyCodename])) {

							if (oldDisplayObject.codename === this.SelectedDisplayObject.codename) Broadcast.call("Selected Display Object Property Changed", [newDisplayObject, propertyCodename]);
							else Broadcast.call("Display Object Property Changed", [newDisplayObject, propertyCodename]);

						}

					} else {

						if (newDisplayObject.codename === this.SelectedDisplayObject.codename) Broadcast.call("Selected Display Object Property Changed", [newDisplayObject, propertyCodename]);
						else Broadcast.call("Display Object Property Changed", [newDisplayObject, propertyCodename]);

					}

				});

				_.each(newDisplayObject.props, (newPropertyValue, propertyCodename) => {

					if (!(propertyCodename in oldDisplayObject.props)) {

						if (newDisplayObject.codename === this.SelectedDisplayObject.codename) Broadcast.call("Selected Display Object Property Changed", [newDisplayObject, propertyCodename]);
						else Broadcast.call("Display Object Property Changed", [newDisplayObject, propertyCodename]);

					}

				});

			}

		} else {

			if (newDisplayObject) {

				if (newDisplayObject['version_id'] === Version.SelectedVersion?.id) Broadcast.call("Selected Version Display Object Added", [newDisplayObject]);
				else Broadcast.call("Display Object Added", [newDisplayObject]);

			} else {

				//Ничего не делаем. Объекта и так не было но пришла информация что его удалили.

			}

		}

	},

	getVersionDisplayObjects(version) {

		return this.DisplayObjectsByVersionByScreenByCodename[version.id] || {};

	},

	selectDisplayObject(displayObject) {

		this.SelectedDisplayObject = displayObject;

		if (this.SelectedDisplayObject) Broadcast.call("Selected Display Object Changed", [this.SelectedDisplayObject]);
		else Broadcast.call("Selected Display Object Cleaned", [this.SelectedDisplayObject]);

	},

	getVersionDisplayObjectsTreeList(version, screenCodename) {

		let displayObjects = this.getVersionDisplayObjects(version);
		let screenDisplayObjects = _.values(displayObjects[screenCodename]);
		let screenDisplayObjectsByCodename = displayObjects[screenCodename];

		//удаляем старые ссылки на дочерние элементы
		_.each(screenDisplayObjects, displayObject => {

			delete displayObject.childs;

		});

		//формируем древовидную структуру (вставляем дочерние элементы в родителей)
		_.each(screenDisplayObjects, displayObject => {

			if (displayObject.parent) {

				let parent = screenDisplayObjectsByCodename[displayObject.parent];
				if (!parent) throw `End Card build error: There are no parent element with id = ${displayObject.parent}`;

				if (!parent.childs) parent.childs = [];
				parent.childs.push(displayObject);

			}

		});

		//сортируем дочерние элементы
		_.each(screenDisplayObjects, displayObject => {

			if (displayObject.childs) displayObject.childs = _.sortBy(displayObject.childs, 'priority');

		});

		return this.extractTreeToList(_.sortBy(_.filter(screenDisplayObjects, o => !o.parent), 'priority'));

	},

	extractTreeToList(displayObjects, result = [], offset = 0) {

		_.each(displayObjects, displayObject => {

			//Не помещаем рутовый элемент (Main Container)
			if (displayObject.parent) {

				displayObject._offset = offset - 1;

				result.push(displayObject);

			}

			if (displayObject.childs && displayObject.options.dashboardExpanded !== false) this.extractTreeToList(displayObject.childs, result, offset + 1);

		});

		return result;

	},

	forEachAllChilds(displayObject, fn) {

		_.each(displayObject.childs, child => {

			fn(child);

			if (child.childs) this.forEachAllChilds(child, fn);

		});

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.DisplayObject) DisplayObject = window.DisplayObject;
else window.DisplayObject = DisplayObject;

export { DisplayObject }

